import React from "react";
import dynamic from "next/dynamic";
import { Placeholder } from "@bloomberg/media-ui-article";

import FeatureContent from "~components/articles/feature/FeatureContent";
import FeatureHeader from "~components/articles/feature/FeatureHeader";
import FeatureLeftRail from "~components/articles/feature/FeatureLeftRail";
import ErrorBoundary from "~components/ErrorBoundary";
import { GridFull } from "~components/GridLayout";
import ViewportComponent from "~components/ViewportComponent";
import { ArticleComponentProps } from "~types/types";
import isEnabled from "~utils/features";

import styles from "./styles.module.css";

const BOA_RECIRC_ENABLED = isEnabled("enableBoaRecirc");

const RecircModule = dynamic(() => import("~components/RecircModule"), {
    ssr: false,
    loading: () => (
        <div className="h-[250px]">
            <Placeholder.Image />
        </div>
    ),
});

export default function Feature({ story }: ArticleComponentProps) {
    return (
        <>
            <ErrorBoundary fallback="Failed to render header">
                <FeatureHeader />
            </ErrorBoundary>
            <div className={styles.featureWrapper}>
                <ErrorBoundary fallback="Failed to render left rail">
                    <FeatureLeftRail />
                </ErrorBoundary>
                <ErrorBoundary fallback="Failed to render body of article">
                    <FeatureContent />
                </ErrorBoundary>
            </div>
            {BOA_RECIRC_ENABLED && (
                <GridFull className={styles.recircWrapper} name="recirc">
                    <ViewportComponent
                        showPlaceholder
                        onRender={(inViewport) =>
                            inViewport && (
                                <RecircModule
                                    id={story.id}
                                    resourceType={story.resourceType || ""}
                                    url={story.url}
                                />
                            )
                        }
                    />
                </GridFull>
            )}
        </>
    );
}
